
import React, { useState } from "react";

const STORAGE_KEY = "s2p5_eliminated_employees";

const EMPLOYEE_IDS = {
  "Alexandre": 101, "Samir": 118, "Clara": 132, "Julien": 147,
  "Yassine": 173, "Zoé": 181, "Martin": 194, "Hugo": 221,
  "Thomas": 248, "Olivier": 272, "Nadia": 286, "Lucas": 297,
  "Amira": 312, "Victor": 328, "Sofia": 341, "Marie": 359,
  "Antoine": 374, "Camille": 389,
};

function getPrenomFromName(name) { return name.split(" ")[0]; }

function useEliminated() {
  const [eliminated, setEliminated] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? new Set(JSON.parse(stored)) : new Set();
    } catch { return new Set(); }
  });
  const toggleEliminate = (id) => {
    setEliminated(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(next))); } catch { }
      return next;
    });
  };
  return { eliminated, toggleEliminate };
}

const PLANNING_DATA = [
  { name: "Alexandre M.", lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Samir H.",     lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Clara N.",     lun: "✓",  mar: "✓",  mer: "🚗", jeu: "🚗", ven: "🚗", note: "Conf. ML Paris mer-ven" },
  { name: "Julien P.",    lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Yassine B.",   lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "🏖️" },
  { name: "Zoé L.",       lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Martin S.",    lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Hugo B.",      lun: "✓",  mar: "✓",  mer: "✓",  jeu: "🏫", ven: "🏫", note: "Formation jeu-ven" },
  { name: "Thomas D.",    lun: "🏠", mar: "🏠", mer: "🏠", jeu: "🏠", ven: "🏠", note: "Télétravail semaine" },
  { name: "Olivier G.",   lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Nadia E.M.",   lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Lucas F.",     lun: "✓",  mar: "✓",  mer: "✓",  jeu: "🏥", ven: "🏥", note: "Arrêt maladie jeu-ven" },
  { name: "Amira B.",     lun: "✓",  mar: "✓",  mer: "🏛️", jeu: "🏛️", ven: "✓", note: "Tribunal mer-jeu" },
  { name: "Victor L.",    lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "🏠", note: "TT vendredi" },
  { name: "Sofia M.",     lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Marie D.",     lun: "✓",  mar: "🚗", mer: "🚗", jeu: "🚗", ven: "✓", note: "Déplacement Lyon mar-jeu" },
  { name: "Antoine L.",   lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
  { name: "Camille H.",   lun: "✓",  mar: "✓",  mer: "✓",  jeu: "✓",  ven: "✓" },
];

function CellValue({ value }) {
  if (value === "✓") return <span className="text-emerald-400 font-bold text-sm font-mono">✓</span>;
  return <span className="text-base leading-none">{value}</span>;
}

export default function PlanningBoard({ onClose }) {
  const { eliminated, toggleEliminate } = useEliminated();

  return (
    <div className="py-8 px-6 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 min-h-[70vh]">
      <div className="max-w-4xl mx-auto">
        <div className="mb-4">
          <div className="text-2xl font-bold text-white mb-1">📅 Planning de la semaine 47</div>
          <div className="text-sm text-slate-400">Semaine du 20 au 24 novembre — Présences bureau</div>
        </div>

        <div className="mb-3 grid grid-cols-2 md:grid-cols-4 gap-2 text-xs text-slate-400">
          {[["✓","text-emerald-400","Présent"],["🏠","","Télétravail"],["🚗","","Déplacement"],
            ["🏥","","Arrêt maladie"],["🏫","","Formation"],["🏛️","","Démarche légale"],["🏖️","","Congé"]
          ].map(([icon, cls, label]) => (
            <div key={label} className="flex items-center gap-1.5">
              <span className={`font-mono font-bold ${cls}`}>{icon}</span>
              <span>{label}</span>
            </div>
          ))}
        </div>

        {eliminated.size > 0 && (
          <div className="mb-3 text-xs text-red-300 font-mono bg-red-500/10 border border-red-500/20 rounded px-3 py-1.5">
            {eliminated.size} éliminé{eliminated.size > 1 ? "s" : ""} — visible dans la grille des portraits
          </div>
        )}

        <div className="bg-slate-900/60 border border-slate-700 rounded-xl overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-950 border-b border-slate-700">
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase tracking-wider">Employé</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-slate-400 uppercase">Lun 20</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-slate-400 uppercase">Mar 21</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-slate-400 uppercase">Mer 22</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-slate-400 uppercase bg-blue-500/10">Jeu 23</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-slate-400 uppercase">Ven 24</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-400 uppercase">Notes</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-slate-400 uppercase">Éliminer</th>
              </tr>
            </thead>
            <tbody>
              {PLANNING_DATA.map((row, idx) => {
                const prenom = getPrenomFromName(row.name);
                const id = EMPLOYEE_IDS[prenom];
                const isElim = id ? eliminated.has(id) : false;
                return (
                  <tr key={idx} className={["border-b border-slate-800 transition",
                    isElim ? "opacity-30 saturate-0" : "hover:bg-slate-800/30"].join(" ")}>
                    <td className="px-4 py-3 text-sm font-medium text-slate-200">{row.name}</td>
                    <td className="px-3 py-3 text-center"><CellValue value={row.lun} /></td>
                    <td className="px-3 py-3 text-center"><CellValue value={row.mar} /></td>
                    <td className="px-3 py-3 text-center"><CellValue value={row.mer} /></td>
                    <td className="px-3 py-3 text-center bg-blue-500/5"><CellValue value={row.jeu} /></td>
                    <td className="px-3 py-3 text-center"><CellValue value={row.ven} /></td>
                    <td className="px-4 py-3 text-xs text-slate-400">{row.note || "—"}</td>
                    <td className="px-3 py-3 text-center">
                      {id && (
                        <button onClick={() => toggleEliminate(id)}
                          className={["px-2 py-0.5 rounded text-[10px] font-mono font-semibold transition-all",
                            isElim
                              ? "bg-red-500/20 border border-red-500/40 text-red-300 hover:bg-red-500/30"
                              : "bg-slate-700/60 border border-slate-600/40 text-slate-400 hover:bg-slate-700 hover:text-slate-200",
                          ].join(" ")}>
                          {isElim ? "❌" : "○"}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <p className="mt-3 text-xs text-slate-500 italic">
          Cliquez sur ○ pour marquer un employé à éliminer — il sera déjà coché dans la grille des portraits.
        </p>
        <button onClick={onClose} className="mt-4 w-full px-4 py-3 rounded-lg bg-slate-700 hover:bg-slate-600 text-white font-semibold transition">
          Fermer
        </button>
      </div>
    </div>
  );
}